import { retrieveCookieValueByName } from "./cookie-finder";
export function pushCustomerContextEvent() {
  const contextCookie = retrieveCookieValueByName('customer_context');
  const eventBus = window['CustomerContextEventBus'];
  if (contextCookie) {
    eventBus === null || eventBus === void 0 ? void 0 : eventBus.emit('CustomerContext.Update', [{
      key: 'STORES',
      value: contextCookie
    }]);
  }
}